<!-- 
화면명 : UCRadio.vue
작성일 : 2025-07-01
설명   : 라디오 컨트롤
-->
<template>
  <div class="flex items-center space-x-2">
    <img src="@/assets/img/blue-circle.png" class="w-3 h-3" />

    <label class="text-blueGray-600 text-sm font-semibold whitespace-nowrap">
      {{ label }}
    </label>

    <div
      class="flex space-x-4 border rounded px-4 py-1 rounded text-sm text-blueGray-700 focus:outline-none focus:ring-2 focus:ring-lightBlue-500"
    >
      <label
        v-for="forData in arrData"
        :key="forData[code]"
        class="inline-flex items-center"
      >
        <input
          type="radio"
          class="form-radio text-lightBlue-500"
          :name="label"
          :value="forData[code]"
          v-model="model"
        />
        <span class="ml-2 text-sm text-blueGray-700">{{ forData[name] }}</span>
      </label>
    </div>
  </div>
</template>

<script setup>
import { ref, defineProps, defineEmits, computed } from "vue";

const props = defineProps({
  label: {
    type: String,
    default: "",
  },
  modelValue: {
    type: [String, Number],
    default: "",
    required: true,
  },
  arrData: {
    type: Array,
    required: true,
  },
  code: {
    type: String,
    default: "",
    required: true,
  },
  name: {
    type: String,
    default: "",
    required: true,
  },
});

const emit = defineEmits(["update:modelValue"]);

const model = computed({
  get: () => props.modelValue,
  set: (val) => emit("update:modelValue", val),
});
</script>
